import DataTableInit from './datatable.js';

$(document).ready(function() {
    if($('.onsitenow-data-table').length) {

        var dataTable = $('.onsitenow-data-table').DataTable({
            processing: true,
            serverSide: true,
            language : {
                sLengthMenu: "Show _MENU_",
                emptyTable: "No Guests currently on site"
            },
            ajax: window.site.onsitenowTableData,
            columns: [
                { data: 'visitId', name: 'visits.id', orderable: true},
                // has to filter on visit_guest.first_name which is filtered in repo, cannot filter on alias
                { data: 'guests', name: 'visit_guest.first_name' },
                { data: 'host_name', name: 'company.company_name'},
                { data: 'company', name: 'visit_guest.company'},
                { data: 'lastVisitDate', name: 'visits.visit_date' },
                { data: 'vehicle_reg', name: 'visits.vehicle_reg' },
                { data: 'visitor_pass_number', name: 'visits.visitor_pass_number'},

            ],
            "fnDrawCallback":function(){
                DataTableInit.handlePaginationState();
                DataTableInit.addDropdownArrows();
                DataTableInit.makeRowsClickable();
                DataTableInit.addDropdownArrowsSelectbox();
            },
            "fnInitComplete":function() {
                DataTableInit.addSearchCross();
                DataTableInit.makeRowsClickable();
            },
            'createdRow': function( row, data, dataIndex ) {
                if(data.type == 'User') {
                    $(row).attr('data-href', window.site.url + '/guest/user/single/' + data.userId);
                } else {
                    $(row).attr('data-href', window.site.url + '/guest/single/' + data.visit_guestId);
                }
            }
        });

        DataTableInit.construct(dataTable);

        dataTable.order( [[ 4, 'desc' ]] ).draw();


    }
});


// WEBPACK FOOTER //
// ./onsitenow-datatable.js